import { Alert, AlertDescription, AlertIcon } from 'components/v4';
import { NAVIGATE_AWAY_WARNING } from 'pages/telephony/numberBlocks/add/constants';

function UploadWarningAlert() {
    return (
        <Alert status="warning" variant="left-accent">
            <AlertIcon />
            <AlertDescription fontSize="sm">
                {NAVIGATE_AWAY_WARNING}
            </AlertDescription>
        </Alert>
    );
}

export default UploadWarningAlert;
